import { PartnerTypeFieldsPermission } from "../models/PartnerTypeFieldsPermission";
import { PartnerTypeFieldsPermissionService } from "../services/PartnerTypeFieldsPermissionService";

export class UserPartnerFieldPermissionManager {

    public static IsPartnerTypeFieldPermissionsLoaded: boolean = false;
    private static PartnerTypeFieldPermissions: PartnerTypeFieldsPermission[] = [];

    public static async initialize(): Promise<boolean>{
        this.PartnerTypeFieldPermissions = [];
        this.IsPartnerTypeFieldPermissionsLoaded = false;
        const partnerTypeFieldsPermissionService = new PartnerTypeFieldsPermissionService();
        const fieldPermissionsData = await partnerTypeFieldsPermissionService.GetForCurrentUserPartnerType();
        if (fieldPermissionsData) {
            this.PartnerTypeFieldPermissions = fieldPermissionsData;
        }
        this.IsPartnerTypeFieldPermissionsLoaded = true;
        return true;
    };

    public static hasReadPermission(objectFieldCode: string, objectTableCode: string): boolean {
        if (objectFieldCode && this.IsPartnerTypeFieldPermissionsLoaded) {
            let permission = this.getPermission(objectFieldCode, objectTableCode);
            return permission ? permission.Read : false;
        }
        return false;
    }

    public static hasWritePermission(objectFieldCode: string, objectTableCode: string): boolean {
        if (objectFieldCode && this.IsPartnerTypeFieldPermissionsLoaded) {
            let permission = this.getPermission(objectFieldCode, objectTableCode);
            return permission ? permission.Write : false;
        }
        return false;
    }

    public static getPermission(objectFieldCode: string, objectTableCode: string): PartnerTypeFieldsPermission | null {
        if (objectFieldCode && this.IsPartnerTypeFieldPermissionsLoaded) {
            let partnerTypeFieldPermission = this.PartnerTypeFieldPermissions
                .filter(p => p.ObjectFieldCode?.toLowerCase() === objectFieldCode?.toLowerCase() && p.ObjectTableCode?.toLowerCase() === objectTableCode?.toLowerCase())[0];
            return partnerTypeFieldPermission ? partnerTypeFieldPermission : null;
        }
        return null;
    }
}